const courseConfig = {
  "LAW6001": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home",
    "courseAiUrl": "http://10.119.14.181:8089/"
  },
  "BUSS8597": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON7004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEDS6012": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BUSS6412": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ME6566": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8029": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "BUSS6427": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8578": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC6504": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PE6122": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "JC8209": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "GE6003": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MEDS6005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6062": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME6540": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS6010": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PE6120": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ECON8020": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8532": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8526": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ICE9212": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS6413": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "BIO9002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BUSS8415": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8412": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8107": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6404": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO6303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MGTS6001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON7005": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE6404H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BUSS8020": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE8612": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BUSS6009": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6005": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PE6200": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6542": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO6203": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEM6001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO8005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6102": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO9001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AP1259": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1262": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AP1207": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AP1226": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1263": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1252": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AP1218": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AP1233": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "AP1257": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1251": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1261": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AP1258": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1250": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AP1247": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AP1260": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AP1256": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1254": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1249": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AP1230": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AP1229": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AP1222": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AP1228": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AP1217": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1255": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1203": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AP1253": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AP1248": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AP1216": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1214": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1211": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AP1209": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AP1201": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "AP1202": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2508": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "KE3401": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS1302": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "JC3174": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE1009": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE4403P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ICE3402P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4414P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY3402P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ICE4408P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE4404P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "POL3690J": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT4710J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AD903": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS4501": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2604": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CS3972": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS3529": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2410": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3517": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2508": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "SOC1136": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS1301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECON2402": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2602": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE0108": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE0501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECON2505": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2501": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2512": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2507": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2509": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2606": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2608": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2514": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2601": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2513": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS2510": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS3636": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2505": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS2603": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2516": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2409": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2509": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2614": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2503": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2301": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2502": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT3060J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH6003J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE6501J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6502J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECE6607J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "HLT3204G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECE6101J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO2731": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM3410": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM3309": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM2207": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "EE0502": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE2800J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH2030J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM2450": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM3438": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "HLT3203G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HLT3205G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LA3324": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "PUM3451": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3326": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "PUM3431": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "LA3320": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA2318": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3401": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LA3317": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA2311": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "DES3308": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3316": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3404": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA4306": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "HLT3601G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HLT3402G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BUSS3501": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3609": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS3601": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3611": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3618": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON6002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON4701": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON7001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9009": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS3605": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECON3621": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3620": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS3603": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECON3606": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3511": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "ECON3602": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3516": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3513": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3510": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3509": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3617": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3505": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CS3312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3345": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SET3401G": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CHEM2406": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "SET3302G": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "SET3603G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS4609": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3627": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3623": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON1104": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3616": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS3508": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3411": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3513": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3619": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3610": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3524": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3521": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1955": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM2317": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "NAOE2310": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PHAR2211": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "NIS3607": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3341": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MED1318": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS3344": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUS2551J": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MATH3306P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PHIL2800J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3316": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3317": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3319": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3320": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home",
    "courseAiUrl": "http://10.119.14.181:8089/"
  },
  "AU2514": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3322": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3327": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM2306": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS3325": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3331": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3321": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3333": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CS3340": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3342": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3511": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3512": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3336": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3507": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS4313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS4315": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4324": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3605": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3367": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4332": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME4405P": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME4401P": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MATH3307P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2404": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON1301": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2403": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS1604": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "NIS4333": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ARCH5305": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CUL2540J": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "AU3601": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3611": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3366": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3363": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3362": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3358": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3356": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3353": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ARCH4307": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH4310": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH4309": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH3405": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH3317": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3640": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH3311": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "SE3332": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE4357": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3352": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3329": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3336": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3302P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3357": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3356": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3354": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY3762": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY3760": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PHY3761": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE3404E": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CHEM3307": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ISE1301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM2405": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHY4761": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHY2308P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHY2304P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHY2306P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BUS2510J": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ME2400J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MATH3705": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AU3311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH1207": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AU3308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3310": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3324": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME2500J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IST3311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE4010J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AU4304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI3702": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI3704": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI3705": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI4701": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ISE4304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3315": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NOAE4315": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3340": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3330": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE4410": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE4313": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "NAOE4301": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3332": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AU3316": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ISE3302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE3318": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3342": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3337": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CE3649": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ISE3310": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3517": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ISE3311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CE3646": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE3336": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ISE3320": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM2110J": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ISE3319": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ISE3318": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE3348": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CE3642": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CE3648": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3645": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3625": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3635": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CS4954": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS4952": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME4403P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ICE4405P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3404P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JCCX0013": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JCCX0004": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JCCX0012": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE4408P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "FL3608P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SET3201G": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PHY3601": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CE3624": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3644": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3614": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3634": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4620": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3627": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3611": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4609": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "NAOE3334": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "FL1341": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "NAOE3326": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ECE2160J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE3612": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CS2307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS0501H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE2606": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE3402E": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CS3962": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3966": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3959": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY3767": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CS3969": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3967": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2988": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3956": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3968": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "FL3302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "LAW1006": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "HIS1014": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MS4304": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS4303": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3704": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3807": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3402": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CHEM5402": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG4407": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MS3502": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3404": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS4601": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3501": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CHEM1214": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MS3403": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CHEM2201": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM3401": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "EE0503": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM3201": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM3303": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4401": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM2407": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM4306": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4307": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE5618": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM4330": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4620": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MATH4304": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BME2208": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CENG4604": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4604": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4303": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4506": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE4704": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM4320": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4708": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4504": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4507": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE5318": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AI3624": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY1302P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE4320": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CENG4504": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG4410": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG4409": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4505": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4410": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG4601": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM5510": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4707": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MATH4704": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH4702": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH3712": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CHEM5501": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4503": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG4403": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM5503": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MATH3706": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CENG4302": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AI3626": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ENVR4201": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AI1202": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1604": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE1302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE1301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE1314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY1304P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "NAOE2306": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "DES3402": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES3302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY3853": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHAR1201": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS2306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM1220": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CENG4701": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG4401": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS2311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2310": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC3225": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CIM4509": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "NIS4307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS2337": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM1471": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EE1401E": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NIS2336": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS2334": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM1315": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EE1402E": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MS1201": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MS1301": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NIS2333": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE2324": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE2322": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS2339": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS2332": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE2302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE1503": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AI1201": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU2651": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2602": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS1335": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE2603": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2619": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE2321": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2611": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2613": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AI2304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3611": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2651": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHAR2212": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR2210": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR2209": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR2207": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR2202": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR2204": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR2203": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NAOE2304": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2511": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MECH3523": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2504": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2521": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE2305": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE2401": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2512": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2520": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2526": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MECH2510": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2502": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MECH2501": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BMS1205": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ICE2601": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1960": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3950": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BMS1207": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS3964": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2986": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2953": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2965": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2206": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2918": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2916": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO2354": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2353": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2352": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2351": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2357": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM2252": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BIO2752": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM4409": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM3404": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM3308": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AU3323": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST2701": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU2301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU4303": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MECH1504": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE2301": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CE1602": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ISE3308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE1302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE2501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ISE3309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO2232": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2610": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2214": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2212": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW2312": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "BIO2801": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW2307": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "IAGR2301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI3411": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2242": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW2319": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "MATH1306P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BIO2402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2503": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO2213": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW1304": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW1306": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "BIO3301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3407": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HIS1301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3731": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2603": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2733": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HIS1507": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR3601": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2210": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO1652": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2206": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM2601": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ICE1301P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MED1304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2203": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED1306": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2340": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2650": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI3412": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT4502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2403": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS1302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS1304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2330": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2803": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHY3651": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MED2353": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS3612": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM1218": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CE2622": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CHEM1216": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CE2603": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "AI3610": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI3618": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "HORT4407": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT4411": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT4410": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3601": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS1303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CE2615": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ME4918": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "HORT3421": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3503": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3422": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3417": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CE2613": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "BIO1261": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3413": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3410": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI3622": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ED2401": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CE2619": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE2606": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "FL4302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "HORT3403": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW2311": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW2315": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "HORT3426": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST3418": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST3416": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "FOST3414": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FL1515": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "FOST3412": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FL1339": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "FOST3404": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST3405": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ARCH3306": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "FL1338": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "FOST3406": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EST2506": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST2301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ICE2305": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ICE2301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST2306": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE2903": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST2304": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE2901": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES1332": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST2305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE2902": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES1409": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE1617": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE1318": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE1618": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "SI1216": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ED1205": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "MSE1319": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BIO1204": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "DES1331": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES3404": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3318": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE2302": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE2302": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE2301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE3805": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE3804": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE4402": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CS1131": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME3808": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE2602": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE3306": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE3305": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3605": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3604": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE2303": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE3803": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE3403": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NU2401E": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3403": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME3806": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME3804": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3502": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME3501": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE3402": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE3303": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3603": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3401": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME3315": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE2604": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECOL3602": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ICE3505": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3519": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME3402": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CS0501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECOL3420": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL3424": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CS3404E": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4501E": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MSE2301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECOL3423": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EST3315": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECOL3417": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EST3309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE2305": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE2603": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE2606": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ICE3307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ASCI2307": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI2502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST2401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL4402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL3422": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL3411": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL3410": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE3314": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ASCI3302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW4509": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "MSE3611": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ASCI2303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI3404": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS1501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "FOST2301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST3501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT2501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT2302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME3305": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE3614": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "FOST2505": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST3420": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3602": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME3308": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE3525": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3524": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3515": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3319": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "HORT3419": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "HORT2303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "EE3315": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3302": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AU3701": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECOL3303": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MSE3312": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "HORT3420": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL2601": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL2501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL2401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR2501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR3602": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR2401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL2701": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR2303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR2304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE3502": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CIM3152": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ME1221": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "EE1503": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE3311": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECOL3506": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CS1901": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ASCI3505": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI3503": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE3610": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST2501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3310": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3321": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO4750": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE3310": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM4550": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ASCI3410": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM2404": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4551": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1202": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ASCI3409": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM2401": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ASCI3407": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI3406": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE3309": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM1602": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1302": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM2203": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "LAW1117": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "CHEM2301": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE3206": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE3205": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE3201": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3224": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3225": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CHEM1306": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4650": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE3202": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE1201": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME3215": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ED2412": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2409": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2306": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2410": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH3402": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2307": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2408": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ED2402": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2304": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2303": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2405": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "DES2321": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MATH1409": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE0501H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME1202H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS2501H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "HLT2102G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "HLT2201G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SET2702G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH1207H": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "SET2301G": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "HLT2101G": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "SET2201G": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME1221H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CHEM0202": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BMS1202": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "EST3307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MED1311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2950": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1964": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME2205": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS1984": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1951": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1966": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1957": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM1305": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS2312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO1307": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO1258": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO1257": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM2205": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MST4308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST4307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST4305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST4303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST3324": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST3323": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MST3321": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NU3202": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3499": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NU3205": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3799": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IE3402": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "IE3403": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MST3319": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST3317": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE2401E": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME2401E": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU4602": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NU4501": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU3401": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU3301": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE2402E": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BME2202": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW4501": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "BME2204": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME2203": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IAGR4601": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME2207": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME2206": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AE2711": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE3303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE2503": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IE3206": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BME3405": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "FOST4601": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL4602": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "HORT4601": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IE3302": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ME3809": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IE3202": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AE2402": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MS2802": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS2601": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS2501": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS2401": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MS2701": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS2801": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NAOE2312": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BME3404": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MST3302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME3311": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME5304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME5302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MST3307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME3403": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MST3305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME3310": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI4601": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MST3314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME3201": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME4202": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME4203": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3410": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3411": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3408": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NAOE2311": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NAOE3347": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BME3406": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MST3308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME3309": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME2402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3414": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3512": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO3511": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3510": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3509": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3506": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3412": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3921": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3733": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI2804": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2801": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2803": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2802": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM2311": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AI2807": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2806": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AI2805": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI1805": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM3328": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EST1103": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "LAW1305": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW2314": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW4432": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "ENVR4306": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LAW3430": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW3424": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "PHY1651": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ENVR4301": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LAW3442": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "PHY1624": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MATH1802": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "LAW4417": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3411": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3408": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3322": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW3320": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW3256": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3321": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "PHY2510": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "LAW1302": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW2318": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LAW2401": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW2316": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "ENVR4228": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4232": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR3207": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR3203": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LAW4416": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW3410": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "ENVR3206": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR3205": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR3202": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PHAR4308": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR4306": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR5301": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR4305": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR3226": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ICE4312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHAR4206": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "EE3308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHAR3220": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "NU4206": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PHAR4309": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME4913": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE4201": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MST4301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST4306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3329": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHN3405": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PHAR3214": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR3225": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR3213": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR3208": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PHAR3207": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NAOE3345": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE3709": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PHAR3206": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHN3426": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CHN3423": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EE3330": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE3507": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MATH3815": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "TE4701": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO3813": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AE3406": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BIO3721": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR3205": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR3204": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BIO3402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3416": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO3802": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NAOE3344": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE2314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE3405": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "EE3323": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE4718": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU3207": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IE2201": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "IE2202": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PE2202": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BIO3203": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PE2201": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IE3204": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ENVR4202": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3603": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO1252": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ENVR4210": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4214": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4222": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4218": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4508": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4505": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO4732": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO4802": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ENVR4304": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO4702": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME2232": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MECH3508": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH3510": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH3531": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ENVR4205": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4209": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4216": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4221": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO4902": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MECH3507": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MECH4502": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "EE4319": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MECH3512": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME2220": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MATH1232": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AI2615": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE2906": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST1104": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ME1147": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MATH3806": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO1111": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW1116": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW1301": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "CE1102": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LAW1303": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW3805": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3806": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW4810": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW4848": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW4809": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "ENVR1107": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BUSS1136": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MS1108": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PREP1206": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SOC1031": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR1121": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AE1109": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AI1115": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST1102": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC3176": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE1003": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME1103": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "LA1001": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CS096": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE1006": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME1146": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SI0012": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE1011": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "SI0013": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ART1129": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SI0014": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SI0010": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "SI0011": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME1130": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "LAW1114": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PUM1117": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ME1125": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BI077": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECON1004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CS1108": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST1108": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS1121": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS1131": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "FOST1109": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MECH1106": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AI1112": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS1128": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BIO1110": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME1135": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "NU1102": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CE1001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS1126": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON1120": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE1008": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BIO0111": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BUSS1135": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON1106": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO0105": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS0101": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME1144": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME1104": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS1132": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CE1002": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECON1102": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO1016": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MS1107": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CE2101": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "MS1004": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PHY0104": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "SOC1029": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "LAW1104": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "CS1001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO0114": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECON1115": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE1110": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECON1003": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO1001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME1007": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ECON1001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "JC1004": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE1105": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE1102": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BIO1004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO1013": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "FOST1106": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AI1104": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEDS1104": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT1103": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MS1001": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AE1104": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME1105": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO1012": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR1102": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE0101": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM1001": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BIO1010": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR1001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS1106": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR1002": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MLS1101": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW1001": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "SP227": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST1107": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AE1106": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU1001": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ENVR0105": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECON1118": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "NU1101": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ENVR1006": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AI1105": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MA194": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS0103": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECON1103": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS0102": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ARCH1003": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "MSE0109": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ARCH1001": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "PUM1128": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECON1114": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE0104": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "SP155": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "SO922": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ME912": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "FOST1104": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO1017": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT1104": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE1010": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE1007": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME1123": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO0107": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT1102": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI1001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO0101": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ENVR1001": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR0101": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AI1114": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME1009": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "LIS1001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ",
    "courseAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS2515": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CS2967": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE1001": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CS1965": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM1102W": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PUM1101W": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM1213": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PREP1205": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH3310P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY3303P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHY2302P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHY2301P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ICE4411P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE4901P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ICE4413P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE4401P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ICE4404P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4407P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3405P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4412P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE6701H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME4901P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME4406P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MATH4403P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "FL4604P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CHEM1350": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "FL4605P": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "FL1335": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ED1202": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME1202": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME1201": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MST1301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1602": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM1304": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1309": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1211H": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1222": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS1601": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI1810": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ENVR3201": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AI1802": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1502H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM2321": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE1615": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MED1305": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE1616": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE1317": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE1316": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BIO1254": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME6520": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NURS1301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NURS1303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM1217": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MED1309": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED1320": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM1215": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1205": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MED1303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED1324": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MED1323": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MED1322": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MED1321": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1211": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1223": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BMS1201": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO1256": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM1208": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1303": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM1212": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS1212": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1950": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1953": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1958": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1983": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO1260": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "VR368": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "BUS2400J": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE2500J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME2110J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BUS4100J": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CHEM2100J": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ENGR1010J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ENGR1000J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ECE2700J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME2350J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CHEM2090J": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ENGR1510J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE4821J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUS1510J": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECE6303J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME4610J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE6202J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6601J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME4670J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6202J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "VK493": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME4580J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME4320J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "STAT4060J": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "VE414": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECE4850J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE4770J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE4820J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE4810J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "VE444": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE4230J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME4500J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE3300J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECE4530J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE3700J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "VE351": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE3730J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE3200J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECE2810J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE4600J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE3340J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECE3110J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME3200J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ECE2150J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE4500J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE3600J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECE4550J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO6202H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PE6441": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BME4302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI1113": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI1401": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ARCH0102": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECON3515": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3514": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3609": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3526": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3520": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS3501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS3401": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECON3615": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3608": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECON3605": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3507": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3504": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3519": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3628": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3622": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3528": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3503": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3621": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3612": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3610": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3503": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3604": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3501": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3619": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3607": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON2601": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON3601": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3604": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS4604": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3505": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3602": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS4607": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECON4702": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9020": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON4602": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON4604": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS4603": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3603": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON4601": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS4701": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON4603": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS4605": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3637": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON7002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON4605": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "HLT4301G": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEDS6004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ISE4302": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM2202": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BUSS2406": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2302": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS2402": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS3620": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS2611": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECON1501": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CE3629": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3643": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "HLT3206G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CE4604": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4615": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "PUM3347": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PUM3401": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "PUM4440": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PUM2316": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "LA4307": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "BIO1003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PUM3321": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH4705": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BME4201": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO1002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME4304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SET3701G": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IAGR3502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME4401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME3303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME4301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SET3901G": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BME4303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME3304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME3306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME3305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME3402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME3307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME3401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME5301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME3302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SET3301G": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CE3607": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3628": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3636": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "BME3301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME5303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CE3630": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE3616": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4607": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4605": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4603": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4601": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4606": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CS4316": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3343": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CS4314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS4504": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3328": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3338": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3339": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS4308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS4303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS4302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2522": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS4304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3310": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CE4613": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "TE4716": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4612": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4610": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4618": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "TE4718": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4617": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "HLT3401G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SET3602G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SO944": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "SE4301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE4355": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3355": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "LA3402": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3319": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3318": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3309": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA4303": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3325": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "LAW3807": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3808": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3804": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3101": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "SE3309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE4353": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3331": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE3353": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO3354": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NIS4350": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4347": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4346": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4345": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4336": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4349": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4348": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4344": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4343": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4341": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4338": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4334": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4315": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3606": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3351": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC3166": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EE4401E": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "NIS4314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS4335": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3368": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE4401E": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "NIS3365": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3364": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3355": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3360": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM4405": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS0502": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2901": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES1311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES3303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IE4901": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH2806": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI1806": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "TE2707": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MECH2508H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "SET2701G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE2308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO8302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2356": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2753": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2355": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHY2509": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PHY1604": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AI1804": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI1811": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "FL4301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE1004": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "FL3361": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH4407": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH3710": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH4701": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH4703": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH3708": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH3711": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "LA3311": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA3307": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LA3302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI3606": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4904": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AI3608": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI3601": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI3621": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ARCH3403": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "SET3601G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ARCH3401": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH3308": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH3307": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "DES3717": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH3304": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CS3953": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM5405": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4705": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM5502": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4451": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM5506": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ARCH4401": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH4304": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH4303": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4619": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE4621": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "EST2505": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ARCH4302": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH4403": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH5303": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CHEM4423": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ARCH4402": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CHEM4421": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4420": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4350": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BIO3752": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ED2406": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ED2201": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2305": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "BIO3351": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ED2302": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2407": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "BIO2201": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3350": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MATH3651": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "LAW4430": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3413": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW1401": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW4428": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW4431": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW3407": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW3409": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW3420": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW3423": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "CHEM2305": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE1115": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "LAW4418": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3402": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "AE2712": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "LAW3403": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW3440": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW2310": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "AU3501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3602": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "LAW3404": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "AI3602": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI3605": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "LAW3319": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "AI3623": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3324": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3318": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3605": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI3703": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE5317": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AI3625": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI3619": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2612": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE5619": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ISE3321": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE4411": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE5617": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE5319": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "NAOE4316": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE4315": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE4314": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3346": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3343": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE4405": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3339": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3329": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME1112": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC3172": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "NAOE3331": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3328": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3312": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE3341": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BMS1986": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM2302": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM3202": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS0902": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BMS1203": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM2251": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM2304": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM3403": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS2951": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2205": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2966": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS3316": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS2312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3608": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3604": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU4606": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES1607": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ED2403": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2404": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH1316": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2301": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "PE3207": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ME3220": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE3401E": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "EE3406E": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE3407E": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CS1129": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3405E": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE3323": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "LAW2309": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "ME3416": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "EE3402E": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE3324": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "FOST4501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST4402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NAOE3325": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ECOL4405": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NAOE3327": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE3204": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE1107": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3413": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MS3801": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME3221": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO3352": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3353": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE4505": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4503": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CS3601": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME3222": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4504": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4431": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4425": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4424": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4506": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4427": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4426": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MS3601": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MSE4430": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4423": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4417": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4411": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4415": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4414": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4412": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4410": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4405": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4404": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MS4701": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3902": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3503": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MSE4422": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4409": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4416": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4413": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4408": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4407": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4402": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4428": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4406": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AI3603": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE4403": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CS1130": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE4401": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CENG2101": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "LA1302": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2309": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ED2411": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ED2203": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "MSE3306": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "HORT4406": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR3222": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR3223": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ASCI4502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR3224": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "HORT4401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE4703": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHAR3210": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "IAGR3302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IAGR2302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR3211": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR3209": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "HORT4405": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR3501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE4705": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE3608": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHAR3202": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHN3422": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CS2309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SE2301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS2331": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS2301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI1111": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "HORT3501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3425": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3424": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3423": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SE1301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ASCI3402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR3403": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR3402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI3501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3418": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3414": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3408": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT3301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI3401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI3303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI3301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL3418": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL3505": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL3421": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL1301": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE4314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECOL3407": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL3304": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "FOST3502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL3419": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL3415": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST3503": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST3410": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "EE4305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4315": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM4406": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "FOST3413": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ICE2502": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3402E": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4901": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "FOST3408": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST4401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS2601": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AU2601": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2618": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI2603": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE2607": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS2602": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JCCX0011": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "JCCX0017": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JCCX0010": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "JCCX0007": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "JCCX0030": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "JCCX0033": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4518": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ISE3307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM4302": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "IST0516": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ISE4301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "EE2508": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ISE3305": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ISE3317": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE3403E": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE3409E": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CHEM5401": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4411": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ICE2304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MS3805": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MS3301": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3701": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS3509": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CENG4413": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "EE4323": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4320": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4322": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ICE3513": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MS3401": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "EST3303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MS3405": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS4901": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS4403": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CHEM4703": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MS3604": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE4321": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHAR3212": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "EE4304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM4408": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR3203": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "EE4308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHAR4207": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR3201": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM4304": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "EE2524": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4310": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM3001": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE4303": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE3332": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE3331": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PHAR4204": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "EE4316": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE4313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE4306": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "EE3320": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE3326": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3528": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE2521": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHAR4202": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR4310": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR4301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR4307": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR4304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR4303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR4203": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR4302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AE3402": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "AE3301": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ICE3301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE3708": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE3407": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "JCCX0031": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST2302": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST3306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JCCX0028": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3901": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE3504": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CENG4406": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG4505": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG4411": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG4405": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MST3301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MECH2507": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH3530": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MECH3529": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH3516": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH4508": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MECH4506": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MST3313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CENG4303": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MECH3519": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH3528": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH3532": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "EST2503": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST2502": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST2303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE2905": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE3307": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE3501": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MST3306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE3313": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE3607": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE3308": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "FOST3407": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHEM4407": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "FOST3402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI3604": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE3613": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CENG4404": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "NU3304": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CENG4402": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "FOST3301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SE3701": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST3322": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MST4311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NU3203": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "TE4704": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "IE3205": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CENG4301": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "TE4711": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "IE3201": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "FOST3421": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AU3302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "TE4710": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO3801": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHN4410": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO3401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3701": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS2984": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO3601": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "TE4707": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO3502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3201": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3911": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ICE4314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3317": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI3607": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO3504": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3732": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3711": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS2987": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST4301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ICE4305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3325": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO3651": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3812": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS3965": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3960": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3319": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE3326": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IE3208": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ICE4309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IE3401": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4315": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS3954": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS1962": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO2222": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS3936": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO3302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2651": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3805": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "EE3304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE4316": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY3751": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AE4404": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE4408": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BIO3405": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AE4304": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MS3406": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE4306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE4512": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE4401": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE4513": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE4407": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE4305": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE4301": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BIO3413": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MECH2519": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2529": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH2527": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW1307": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW2313": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "PE4305": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE4303": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE4403": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE4404": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ME4601": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME4302": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME4602": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BIO3415": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PE4901": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME4501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME4406": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU3325": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY3757": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST3304": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST4307": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST3301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY3852": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY3851": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME4502": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "EST3313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST3305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST3302": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BIO3503": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI3701": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO3514": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO3305": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3507": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3505": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MS3602": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO4801": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO4901": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2252": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AU4302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO4401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO4701": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2202": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO3406": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI4702": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3310": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME4409": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME4503": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE3324": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME4806": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ICE4301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IE4402": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IE4303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NU4309": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IE4401": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ENVR4509": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NU4305": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU4304": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME4805": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "IE4301": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU4601": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ENVR4501": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NU4302": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ENVR3209": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ENVR3208": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NU4401": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ENVR4230": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4408": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4224": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4223": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ENVR4219": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4217": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4211": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4208": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4213": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4207": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4206": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ICE3311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ENVR4229": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4305": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NU4203": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ENVR4225": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4204": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CS1002": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU1101": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI1003": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO1103": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AI1103": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHAR1101": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BI920": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "NAOE0102": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "LAW1005": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "MS0101": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NU0101": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CS155": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EV902": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BI900": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE0103": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BI904": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MSE1108": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EC905": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO0103": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ENVR0104": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO0106": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SI0015": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ENT1402": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO1018": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IST1001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE2203": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE2201": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "GA901": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CHEM1201": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PUM1305": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PUM2360": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PUM1468": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SP190": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ENVR4231": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR4302": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR3204": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO2230": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2732": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ENVR4220": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO2240": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2551": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO2751": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PUM1123": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "BIO1007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "LAW1008": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "CS081": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIO2241": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2602": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2231": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2257": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2256": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO2653": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SE1102": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BU426": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BM026": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI2501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IAGR3401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL2302": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "HORT2503": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT2301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ME2415": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ASCI2305": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI2301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IE2203": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE2605": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ASCI2503": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI2302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT2502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO0112": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST1001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BI903": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE2304": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "FL1126": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MS2301": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BME2305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME2106": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME2303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AM062": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AM072": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "SO941": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO8202": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL0102": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FL1125": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM0101": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CS1107": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM1109": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ECON1002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PL028": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BI916": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MI002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "EV904": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "AI1006": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "GA903": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ME055": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE0101": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "TA001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "SOC1026": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MS0103": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BU007": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EC016": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "SE1101": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ENVR1005": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "SOC1027": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NA010": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE031": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "STAT1001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AE1002": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME908": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CE0101": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "FT0101": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AM043": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ENVR1007": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MSE1111": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BIO0102": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "SP267": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MT023": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AM007": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE1004": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BUSS1102": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CS079": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ME1145": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "SP245": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PU981": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AI1005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MS1005": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "SP062": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "HORT1105": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AM904": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BU102": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BU008": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEDS6003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PubH7001H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6017": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED7011H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6061": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "STOM6001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6069": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6018": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6075": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MED7005H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED7004H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MT6008": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MT6007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MT6003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MT6002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6033": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "STOM6004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "STOM6002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PubH6038": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PubH6002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PubH6001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEDS7006H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7001H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6041": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6039": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6022": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6010": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6008": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6007": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MEDS6006": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6001": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MED7017H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED7009H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MED6074": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MED6050": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6034": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6033": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6030": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6029": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6026": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6025": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PSY9006": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PSY9005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "GE6010": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "GE6009": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS9001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI8002": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI8001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE6105G": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6104G": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6102G": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE6101G": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6102G": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ME6101G": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECE6806G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6805G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6802G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECE6503G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6502G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6501G": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PE8700": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE7702": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE6700": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "NU7702E": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "NU7700": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE8701E": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MGTS6700E": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EE9700": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS9402": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8803": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MS8802": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8801": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MS8709": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8706": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8704": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8703": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8702": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8701": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8608": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8602": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8503": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8502": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8501": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8414": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8412": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8411": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8409": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8407": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8401": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS6301": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LA8307": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA8306": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA8304": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA8042": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "DES9201": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES8205": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES8204": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES8108": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES7103": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES6105": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ARCH8305": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH8303": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH8302": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH8202": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH8101": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH6402": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH6401": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH6301": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH6101": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "BIO8506": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8505": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6504": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6503": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MEM6402": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6006": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AE9901": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE9105": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE9010": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE9005": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE9001": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8901": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8604": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8603": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8602": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8133": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8131": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8130": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8129": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8127": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8125": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8122": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8116": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8113": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8109": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8105": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AE8103": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE7601H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE7002": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6703": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6106": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AE6005": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6003": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "GE6022": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE8326": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8324": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ECON9605": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9603": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9600": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8743": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8710": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "ECON8678": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8674": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8670": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8623": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8622": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8618": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON6613": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECE6704J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS6608": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8802": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6826": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6824": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6818": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6810": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MEM6802": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM6003": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "GE6021": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EDU8501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE8643": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE8637": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE8635": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE8633": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE8631": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE8621": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE8613": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE6607": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MATH6015": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ENVR8173": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR8170": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR8168": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR8167": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR6155": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "JC8823": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "DCCM8830": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "DCCM8824": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DCCM8801": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE7506P": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE6410P": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE6409P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE6408P": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE6311P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6902P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6901P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6402P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6308P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MATH6310P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH6308P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH6304P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH6303P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ICE6418P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6416P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6415P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6410P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6403P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6402P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "GE6621P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "GE6618P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "GE6617P": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "GE6615P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "GE6613P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "GE6612P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MARX9206": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "JC8501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC8232": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC7002": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC6015": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC6009": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CIM6005": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "LAW6942": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6919": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6903": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6886": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6866": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6847": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6839": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6835": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6831": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6816": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6800": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6725": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LAW6637": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6616": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6612": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6604": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6550": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6517": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6514": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6473": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6468": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6467": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6459": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6456": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6452": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6432": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6429": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6426": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6421": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6417": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6410": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6279": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6262": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6246": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6231": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6224": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6215": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6208": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6199": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6197": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6180": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6168": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6146": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6143": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6142": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6106": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6101": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6003": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6002": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "PHAR7123": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR7122": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR7111": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR7102H": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6122": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR6119": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6113": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6110": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6102": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MEM6707": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6705": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM6702": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM6004": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ENVR9003": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ENVR7111": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7110": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7105": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7102H": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7101H": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7021": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7020": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7011": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7008": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7007": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7006": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7004H": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7002": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR6012": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PVET8022": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PVET8006": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PVET6012": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PVET6005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PVET6001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT9002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT9001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT7007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT7006": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT7004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8019": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8012": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8011": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8010": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST7001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL8012": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL8010": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL8003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL6009": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL6006": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL6003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL6002": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ASCI6006": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ASCI6002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI8033": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AGRI8032": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI8004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AGRI6041": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI6040": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI6009": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "FL9104": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "FL9103": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "FL8508": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "FL8132": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM8013": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PUM6606": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PUM6308": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PUM6307": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "POL8013": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8037": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS8036": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS8035": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS8033": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS8025": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8024": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8023": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8017": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8012": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8011": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8010": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS8009": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS6004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9028": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9025": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9024": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9015": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9009": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8736": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8707": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8668": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8120": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8118": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8117": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "ECON8112": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8109": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8108": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8106": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECON8101": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8018": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8017": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8015": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8012": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECON8010": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON6101": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9028": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS9027": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9024": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9023": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9018": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9016": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9010": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9008": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9007": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9006": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8669": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8564": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8548": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8544": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8522": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8517": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8508": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BUSS8504": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8501": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8487": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8474": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8473": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8471": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BUSS8467": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8449": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8443": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8436": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8426": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8423": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8416": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8402": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8390": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8383": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8380": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8378": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8375": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8372": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8367": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8363": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BUSS8355": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BUSS8342": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8337": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8326": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8312": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8310": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8308": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8307": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "BUSS8106": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8104": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8102": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8031": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8030": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8028": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8023": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8022": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8016": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8015": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8014": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8013": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8011": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8006": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6438": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6432": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "BUSS6431": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6428": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6425": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6424": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6420": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "BUSS6419": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6411": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6410": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6408": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6406": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6403": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6402": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6321": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6317": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS6316": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS6311": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6309": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6307": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6305": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6302": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6104": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6103": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6012": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6007": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CHEM9106": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM9105": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM9104": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM9103": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM9102": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM8504": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM8502": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM7301H": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6601": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6509": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CHEM6505": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6504": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6503": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6403": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6301": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6207": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM6203": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6103": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG8101": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CENG7201H": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG6301": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG6202": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG6201": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG6104": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "HST8025": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CHN8808": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "GE7002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME9002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME9001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8308": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8307": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8306": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8305": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8205": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8204": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BME8203": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BME8121": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8117": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8115": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8114": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8107": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8104": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8103": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7303": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7104": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7103": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7102": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7101": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME6005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME6001H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME5104": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME5102": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEM6607": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6606": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEM6605": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIOE8502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIOE8501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIOE6201": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIOE6102H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8106": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8103": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BIO8007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6403H": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BIO6402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6305": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6204": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6101": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHY9310H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8403": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY8311": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8308": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8211": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHY8210": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8207": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8205": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8102": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8101": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHY6301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY6202": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY6201": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "STAT9115": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT8004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT8003": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT8002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT8001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6127H": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6126": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6123": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "STAT6115": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "STAT6108": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6102": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH9216": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH8201": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH8013": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH8004": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH8002": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MATH6211": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH6115": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE9601": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE9312": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE9311": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE9308": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE9304": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE9303": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE9302": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8608": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE8601": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8509": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE8508": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8506": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8501": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8403": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8402": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE8401": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8350": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8349": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8347": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8343": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8342": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8341": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8340": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8339": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8338": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8336": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE8323": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8322": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8321": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8318": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8317": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8316": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE8314": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8310": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MSE8309": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8307": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8306": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8305": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8303": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6604": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6603": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6601": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6405H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MEM6503": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EST8818": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8813": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8812": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8802": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8721": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8720": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8719": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8713": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "EST8710": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8706": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8705": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8701": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6810": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6707": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6705": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6704": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI8705": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI8703": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6713": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6712": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6711": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6708": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6704H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS8705": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS8703": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS8702": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8027": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8026": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8023": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8022": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8020": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8018": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8017": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8013": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8012": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8011": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7025": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7024": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7022": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7020": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7019": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7018": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7008": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7006H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST8017": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST8015": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "IST8009": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST8006": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST8004": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST6006": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST6004H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST6002H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8310": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ICE8106": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7213": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7206": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6510": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6509": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6403": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6303H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6209": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6208": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6207": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6205": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8209": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST7308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST7104": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6311": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6310": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6309H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6207": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6103H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CS7361": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7360": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7359": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7356": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7355": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7353": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7352": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7347": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7344": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7341": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7338": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7336": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7333": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7332": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7331": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7327": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7324": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7321": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7320": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7317": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7316": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7315": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "CS7312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7048": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7047": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7043": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7042": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7039": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7036": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7026": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7023": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7016": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AU7015": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7008": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7006": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7005": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7002": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU6011": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU6005": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU6004": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9015": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9014": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9009": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9008": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EE9006": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9005": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8019": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8018": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE8017": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8012": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8009": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8008": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8004": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE8003": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE8001": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE7022": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7017": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7016": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EE7013": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7012": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7011": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7009": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7007": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7006": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE7002": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM6310": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6307": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM6305": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6303": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6301": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PE8546": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE8540": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE8422": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE8200": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE8120": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE7540": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE7426": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE7126": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE7124": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE7106": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6508": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6504": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6442": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "PE6422": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6420": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE6404": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6300": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6221H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6220": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6202": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6145": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6108": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE6106": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE6103": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE6101H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6100": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU8108": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU8102": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU8100": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6138": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6136": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "NU6134": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6132": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6114": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6108": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6104": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6102": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MEM8248": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8247": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8246": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8243": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8242": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8241": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8237": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8201": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6204": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6202": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ME8560": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "ME8522": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME8520": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME8502": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME8400": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME8340": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME8320": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME8206": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME8200": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME7904": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME7902": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME7900": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ME6523": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6522": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6503": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6426": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6423": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6420": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6320": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6210": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6207": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6204": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6202": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6200": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6160": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6152": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6151": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6146": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6140": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6125": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6124": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6123": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6120H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6120": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6105": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6104": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IE6116": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IE6112": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "IE6107": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IE6101": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE8312": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE8309": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE8103": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "TE6308": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE6307": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE6306": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE6305": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE6304": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE6303": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "TE6301": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "TE6201": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "TE6102": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "NAOE9111": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE9110": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE9107": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE9106": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE9104": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE9102": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8402": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8201": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE8122": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8116": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8114": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "NAOE8110": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8109": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8108": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8107": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7305": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7302": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7301": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7205": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7202": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7201H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7114": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7110": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7108H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7106H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7102": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7101": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE6002": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MEM8101": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "MECH9403": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "MECH8303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MECH8206": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MECH8204H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MECH8202": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MECH8102": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH7101": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH6402": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MECH6308": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH6104": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8220": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8218": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8215": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8214": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8210": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8208": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8207": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8204": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8203": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8202": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8115": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8112": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8108": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CE8104": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CE8103": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8021": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8019": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8018": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8014": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8013": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8011": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8008": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CE8007": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8006": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CE8003": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8002": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6202": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6201": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6101H": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6005": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6004": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6001H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BUSS6426": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PubH6007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6070": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6009": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED7003H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6067": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6063": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MED6058": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6006": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6020": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED7006H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED7015": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6068": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6066": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6065": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6016": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6015": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6014": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6012": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6008": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6064": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6024": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED7002H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED7001H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6059": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6023": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6011": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6056": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6049": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6022": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6021": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MT6006": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MT6004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MT6001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "STOM7001H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "STOM6006": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "STOM6005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "STOM6003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6024": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PubH6039": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PubH6032": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PubH6015": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PubH6009": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PubH6004": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEDS7015": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7014": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7013": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7012H": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MEDS7011H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7010H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7009H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7008H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7007H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7005H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7004H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7003H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS7002H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6044": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6043": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6040": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6038": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6037": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6036": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6034": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6032": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6023": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6019": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6018": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6017": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6015": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MEDS6014": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6013": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6011": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6009": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEDS6002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6032": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6060": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6028": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MED6027": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PSY9007": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI9001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI7003": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI7002": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AI7001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE6106G": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6103G": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6401G": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MATH6101G": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ECE6807G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6803G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6801G": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6101G": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE8708E": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE8706E": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE8702": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE7700": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MEM8901": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE7700": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS9301": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8804": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8707": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8705": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8605": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8507": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8505": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8410": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8408": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS8406": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS6801": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS6701": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS6601": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS6501": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MS6401H": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LA8504": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LA8502": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LA8501": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LA8403": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LA8009": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA6203": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "LA6102": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "DES9102": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES8104": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "DES6301": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ARCH8406": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH8304": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH8301": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH8203": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH8002": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH6103": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ARCH6102": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "BIO8508": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8503": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6502": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6501": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEM6408": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM6407": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6403": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6401": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AE9604": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE9602": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE9401": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE9106": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AE9102": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8606": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8605": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8601": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "AE8128": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8124": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8123": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8121": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8120": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AE8119": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AE8115": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AE8107": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8106": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE8104": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AE8102": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "AE7602H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6704": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6701": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6108": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AE6104": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6102": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6004": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6002": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "AE6001": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE8335": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM6402": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BIO6002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECON9604": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9601": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8763": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8745": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8689": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECON8665": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECON8664": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8661": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8627": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON6612": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT4510J": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE6802J": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MSE6601J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE4930J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6801J": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6104JH": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ECE8601J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE7605J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6903J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6707J": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ECE6308J": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MGTS6606": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6825": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6823": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM6822": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM6821": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6820": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM6819": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6817": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6816": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6809": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6807": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6805": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PE8641": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE8639": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE8629": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE8627": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE8623": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE8611": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE6619": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE6617": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE6615": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE6611": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE6201": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ENVR8174": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR8169": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR8166": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR8165": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR8163": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7103": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR6154": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ENVR6153": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR6152": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "JC6804": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "JC6802": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PE7903P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE7902P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE7901P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6302P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME7903P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME7902P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME7901P": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6501P": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6403P": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MATH6306P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ICE7903P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7902P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7506P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6419P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6405P": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "GE6620P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "GE6614P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "GE6611P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "GE6610P": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "GE6609P": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "HST8041": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC9205": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "JC8502": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC8233": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC8231": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "JC8230": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CIM6002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CIM6001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "LAW6941": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6934": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6927": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6926": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6922": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6914": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6900": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6888": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6887": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6877": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6867": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6858": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6857": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LAW6856": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6838": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6828": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6827": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6812": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6804": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6722": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LAW6721": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "LAW6678": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6638": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6623": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6620": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6618": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6615": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6614": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6613": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6606": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6579": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6548": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6538": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6535": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6530": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6525": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6507": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6471": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6469": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6466": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6446": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6425": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6419": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6413": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6408": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6400": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6323": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6321": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6320": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6318": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6317": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6313": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6298": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6297": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6265": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6261": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6252": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6244": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6239": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "LAW6213": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6207": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6198": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6182": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6181": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6177": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6160": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6156": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6150": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6148": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6139": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6138": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6137": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6131": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "LAW6130": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "PHAR8115": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR8114": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR8113": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHAR8101": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR7114": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR7108": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR7106": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHAR7104": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6201": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6121": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6120": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6118": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6117": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PHAR6116": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6115": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6112": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6111": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PHAR6109": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PHAR6108": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MEM8709": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM8702": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8701": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM6704": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM6703": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM6701": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR9001": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR8101": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7106": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7104": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7019": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7018": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7017": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7016": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7015": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7014": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7013": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7010": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7009": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7005": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR7001": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR6101": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR6017": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR6015": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR6014": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ENVR6013": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PVET8002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PVET6003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT8014": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "HORT8013": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT8012": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT8011": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT8010": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT8008": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT8007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT8004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT8002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT7005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT7003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT7001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT6004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT6003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "HORT6001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST9002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8020": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8018": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8009": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8008": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8006": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST8002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST7003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST7002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST6007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST6005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST6004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST6003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "FOST6001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL9003": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL8016": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL8015": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ECOL8011": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL8005": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL6008": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL6005": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL6004": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "ECOL6001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI8001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI7007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI7003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI7001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "ASCI6004": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI8001": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI6011": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI6010": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "AGRI6008": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI6007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI6005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI6003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI6002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "AGRI6001": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "FL8110": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PUM8612": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PUM8606": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "POL8011": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "POL6303": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "POL6201": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS8038": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS8032": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS8022": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8021": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS8018": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS8016": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MGTS8001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MGTS6003": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MGTS6002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9022": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9021": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9020": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9018": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9017": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9016": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9014": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9005": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON9002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8119": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8116": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8113": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8111": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8107": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8105": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8104": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8103": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8021": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8014": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8008": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8005": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON8002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON6104": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON6103": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON6102": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ECON6003": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9029": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9025": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS9022": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9021": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9019": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9017": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9013": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9012": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9011": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9005": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9003": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS9001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8665": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8558": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8521": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8481": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8472": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8452": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8395": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8394": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "BUSS8393": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8391": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8384": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8382": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BUSS8379": {
    "subjectAiUrl": "https://sjtuaistudy.libsp.cn/#/home"
  },
  "BUSS8376": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8373": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8371": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8358": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8354": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8352": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8350": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8347": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8343": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8338": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "BUSS8333": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8331": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS8325": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8322": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8309": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8305": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8303": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8105": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8103": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8101": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8032": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8026": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8025": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8021": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8018": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8010": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8007": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS8005": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6430": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6415": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6409": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6401": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6342": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6341": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS6315": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS6314": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BUSS6308": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6306": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6304": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6303": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6301": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6102": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6101": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6013": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6011": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "BUSS6006": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8602": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MEM8601": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM9502": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM9501": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CHEM9101": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM7101H": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6507": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6506": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6502": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6501": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6401": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6205": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6202": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6201H": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6201": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CHEM6102": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG9201": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG6401": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG6302": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG6203": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG6102": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "CENG6101H": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "BME8302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8206": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8120": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8119": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8118": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8116": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8113": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8106": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8102": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8009": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME8008": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7202": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7201": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "BME7109": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7107": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7106": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7005": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7003": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME7002": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BME6010": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME6009H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME6008": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME6007": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME6006": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME6003H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME6002H": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME5105": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BME5103": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEM6608": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEM6604": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MEM6601": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIOE8403": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIOE8402": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIOE8401": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIOE8103": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIOE8102": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "BIOE6402": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIOE6304": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIOE6301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIOE6203": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8405": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8404": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8401": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8305": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO8303": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "BIO8204": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8203": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO8104": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6601": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "BIO6301": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHY9212H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8402": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8307": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8305": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8304": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8303": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8203": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PHY8106": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "PHY8105": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "STAT9132": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MSE9314": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE9313": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE9306": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE9305": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE9301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8611": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8606": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8605": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8603": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8404": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8351": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8348": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8345": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8344": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8331": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8330": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8329": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8328": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE8327": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "MSE8319": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8313": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8311": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MSE8304": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MSE8302": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE8301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6403": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6309H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6308H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6308": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6307": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6306": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6303": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MSE6301": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MEM8504": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "MEM8502": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6502": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "EST8819": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8817": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8816": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8815": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8814": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8811": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8809": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8808": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8806": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8805": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8723": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8722": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8718": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8717": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8707": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8703": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8702": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6815": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6814": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6809": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6808": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6807": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6806": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6805": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6804": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6803H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6803": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6802": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6801": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6710": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6706": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6703": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6702": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6701": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EI8709": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI8702": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6710": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6709": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6707": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6705": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6703": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6702": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6701": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8025": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8024": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8021": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8019": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8016": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8015": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS8014": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7023": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7021": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7009H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7007": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NIS7001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH6010": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST9002": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IST9001": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IST8016": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "IST8008": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "IST8007": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IST8005": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IST8003": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "IST6026": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "IST6013": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST6009": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "IST6007": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "IST6005": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "IST6001H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE9001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE8508": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE8304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE8214": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7501": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7401": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7302H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7210H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7201": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7107": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE7101": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6503": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6502": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ICE6402": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6211": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6203": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6202H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6104": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ICE6102": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST9312": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST8208": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8202": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST8201": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST7306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST7303H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST7302": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST7301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST7101": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6401": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6305": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EST6206": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6205": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6203": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "EST6102": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CS7362": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7357": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7354": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7351": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7346": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7345": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7342": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7335": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7328": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "CS7323": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7319": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7314": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7313": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7310H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7308": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7306": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7304H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CS7303": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EI6201": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7046": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7045": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7044": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7040": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7037": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7033": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7032": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AU7024": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7022H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7021": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7018H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7017": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7013H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7011": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7010": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AU7009": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU7003": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "AU6017": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "AU6008": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9018": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9017": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9016": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9011": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9007": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9004": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE9003": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8016": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8010": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8007": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE8005": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "EE8002": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7026": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "EE7025": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7023": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7020": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7015": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7014": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7010": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7008": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7004H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7003H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "EE7001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8307": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8306": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM8304": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8302": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM6311": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "MEM6309": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM6304": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PE8550": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE8549": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "PE8544": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE8400": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE8140": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE6544": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "PE6542": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "PE6523": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6502": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6424": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6408": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6402": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "PE6221": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6208": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6207": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "PE6201H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6140": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6125": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "PE6123": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU8126": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU8106": {
    "subjectAiUrl": "https://j1q.cn/i0Tevc94"
  },
  "NU6130": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6124": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6122": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6121": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6118": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6116": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6112": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6106": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NU6100": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MEM8245": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM8236": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "MEM8235": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MEM8234": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8233": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8231": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8206": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8204": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM8203": {
    "subjectAiUrl": "https://j1q.cn/CD9lgEzy"
  },
  "MEM8202": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MEM6201": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "ME8562": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME8500": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME8322": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME8204": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME7429": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME7166": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME7162": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6540H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6521H": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6500": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "ME6301": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6180": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "ME6149": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6142": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6126": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "ME6122": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "ME6100H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "IE6104": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "IE6102": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE8316": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE8315": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "TE8314": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE8311": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "TE8305": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE6302": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "TE6103": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "TE6101": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "NAOE9202": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE9201": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE9109": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE9108": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "NAOE8126": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8125": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8124": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8119": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8115": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8112": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8111": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8106": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8105": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE8101": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7306": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7304": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7303": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7203": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7115": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7112": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7111": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE7103": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "NAOE6401": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "NAOE6001": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MECH9302": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH8401": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH8302": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MECH8205": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH8201": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH8103": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "MECH7303": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH7301H": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH6404": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "MECH6306": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH6301": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH6202": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH6201": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH6106": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH6105": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MECH6001": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "CE8221": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8219": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8216": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "CE8211": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8209": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8117": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8116": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8111": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8110": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8109": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CE8107": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8106": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8105": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8101": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8022": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE8017": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "CE8016": {
    "subjectAiUrl": "https://j1q.cn/uHbP52Fq"
  },
  "CE8010": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6204": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6203": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6003": {
    "subjectAiUrl": "https://j1q.cn/dWeF27uf"
  },
  "CE6002H": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "GE6008": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "GE6005": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "MED6038": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "MSE9329": {
    "subjectAiUrl": "https://j1q.cn/WdkFR2f7"
  },
  "STAT6002": {
    "subjectAiUrl": "https://j1q.cn/4WNrxnCj"
  },
  "STAT6133": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6131": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6128": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6125": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6121": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "STAT6116": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6110": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6109": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6106": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT6105": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH9122": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH8012": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH8011": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH8010": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH8009": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH6205": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH6112": {
    "subjectAiUrl": "https://j1q.cn/BF7Jbdm1"
  },
  "STAT7002": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "STAT7001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "STAT6005": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  },
  "MATH7003": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH7001": {
    "subjectAiUrl": "https://j1q.cn/EeKmKX0h"
  },
  "MATH6015H": {
    "subjectAiUrl": "https://j1q.cn/MfbQq8JZ"
  }
};

export default courseConfig;
